// Copyright (c) Docugami, Inc. All rights reserved.

import { Logger, LoggerCategory } from "utils/Logger";
import { TelemetryEvent, TelemetryPageView } from './TelemetryEvents';
import { ITelemetryProvider, TelemetryEventData, TelemetryInitializer } from "./TelemetryProvider";

const chmln = require('@chamaeleonidae/chmln');

export class ChameleonTelemetryProvider implements ITelemetryProvider {

    get providerId(): string { return "chameleon" }

    constructor() {
        Logger.LogInformation(LoggerCategory.Telemetry, `Chameleon provider initialized.`);
    }

    trackNamedEvent(name: TelemetryEvent | string, data?: TelemetryEventData): void {
        chmln.track(name);
    }

    trackPageView(name: TelemetryPageView | string, data?: TelemetryEventData): void {
        chmln.track(`WebAppPageView_${name}`);
    }

    trackException(error: Error, data?: TelemetryEventData): void {
        // Intentionally left blank, we are not sending exceptions to chameleon.
    }

    setUserContext(userId: string, accountId: string): void {
        // intentionally left blank, chameleon initialization is done outside the provider.
    }

    clearUserContext(): void {
        // intentionally left blank, chameleon no longer supports clearing context.
    }

    addInitializer(initializer: TelemetryInitializer): void {
        // Intentionally left blank, for now we are not sending any additional data to chameleon.
    }
}
